"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var mobx_react_1 = require("mobx-react");
var React = __importStar(require("react"));
var react_intl_1 = require("react-intl");
var Email_1 = __importDefault(require("../../icons/Email"));
var Phone_1 = __importDefault(require("../../icons/Phone"));
var Website_1 = __importDefault(require("../../icons/Website"));
var utils_1 = require("../../utils");
var Avatar_1 = __importDefault(require("./Avatar"));
var CoverPicture = function (_a) {
    var botInfo = _a.botInfo;
    return (React.createElement("div", { className: 'bpw-botinfo-cover-picture-wrapper' },
        React.createElement("img", { className: 'bpw-botinfo-cover-picture', src: (botInfo.details && botInfo.details.coverPictureUrl) ||
                "https://via.placeholder.com/400x175?text=".concat(botInfo.name) })));
};
var BotInfoPage = /** @class */ (function (_super) {
    __extends(BotInfoPage, _super);
    function BotInfoPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.changeLanguage = function (e) { return __awaiter(_this, void 0, void 0, function () {
            var lang;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        lang = e.target.value;
                        return [4 /*yield*/, this.props.updatePreferredLanguage(lang)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    BotInfoPage.prototype.componentDidMount = function () {
        var _a;
        (_a = this.btnEl) === null || _a === void 0 ? void 0 : _a.focus();
    };
    BotInfoPage.prototype.renderDescription = function (text) {
        var html = (0, utils_1.renderUnsafeHTML)(text, this.props.escapeHTML);
        return React.createElement("div", { className: 'bpw-botinfo-description', dangerouslySetInnerHTML: { __html: html } });
    };
    BotInfoPage.prototype.render = function () {
        var _this = this;
        var _a = this.props, botInfo = _a.botInfo, botName = _a.botName, avatarUrl = _a.avatarUrl;
        var onDismiss = this.props.isConversationStarted ? this.props.toggleBotInfo : this.props.startConversation;
        return (React.createElement("div", { className: (0, classnames_1.default)('bpw-botinfo-container', {
                'bpw-rtl': this.props.rtl
            }) },
            React.createElement(CoverPicture, { botInfo: botInfo }),
            React.createElement("div", { className: 'bpw-botinfo-summary' },
                React.createElement(Avatar_1.default, { name: botName, avatarUrl: avatarUrl, height: 64, width: 64 }),
                React.createElement("h3", null, botName),
                this.renderDescription(botInfo.description)),
            botInfo.details && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: 'bpw-botinfo-links' },
                    botInfo.details.phoneNumber && (React.createElement("div", { className: 'bpw-botinfo-link' },
                        React.createElement("i", null,
                            React.createElement(Phone_1.default, null)),
                        React.createElement("a", { target: '_blank', href: "tel:".concat(botInfo.details.phoneNumber) }, botInfo.details.phoneNumber))),
                    botInfo.details.website && (React.createElement("div", { className: 'bpw-botinfo-link' },
                        React.createElement("i", null,
                            React.createElement(Website_1.default, null)),
                        React.createElement("a", { target: '_blank', href: botInfo.details.website }, botInfo.details.website))),
                    botInfo.details.emailAddress && (React.createElement("div", { className: 'bpw-botinfo-link' },
                        React.createElement("i", null,
                            React.createElement(Email_1.default, null)),
                        React.createElement("a", { target: '_blank', href: "mailto:".concat(botInfo.details.emailAddress) }, botInfo.details.emailAddress)))),
                botInfo.details.termsConditions && (React.createElement("div", { className: 'bpw-botinfo-terms' },
                    React.createElement("a", { target: '_blank', href: botInfo.details.termsConditions },
                        React.createElement(react_intl_1.FormattedMessage, { id: 'botInfo.termsAndConditions' })))),
                botInfo.details.privacyPolicy && (React.createElement("div", { className: 'bpw-botinfo-terms' },
                    React.createElement("a", { target: '_blank', href: botInfo.details.privacyPolicy },
                        React.createElement(react_intl_1.FormattedMessage, { id: 'botInfo.privacyPolicy' })))))),
            botInfo.languages.length > 1 && (React.createElement("div", { className: 'bpw-botinfo-preferred-language' },
                React.createElement(react_intl_1.FormattedMessage, { id: 'botInfo.preferredLanguage' }),
                React.createElement("select", { value: this.props.preferredLanguage, onChange: this.changeLanguage }, botInfo.languages.map(function (lang) { return (React.createElement("option", { key: lang, value: lang }, lang.toUpperCase())); })))),
            React.createElement("button", { tabIndex: 1, ref: function (el) { return (_this.btnEl = el); }, className: 'bpw-botinfo-start-button', onClick: onDismiss.bind(this, undefined) }, this.props.isConversationStarted ? (React.createElement(react_intl_1.FormattedMessage, { id: 'botInfo.backToConversation' })) : (React.createElement(react_intl_1.FormattedMessage, { id: 'botInfo.startConversation' })))));
    };
    return BotInfoPage;
}(React.Component));
exports.default = (0, mobx_react_1.inject)(function (_a) {
    var store = _a.store;
    return ({
        botName: store.botName,
        botInfo: store.botInfo,
        avatarUrl: store.botAvatarUrl,
        startConversation: store.startConversation,
        toggleBotInfo: store.view.toggleBotInfo,
        isConversationStarted: store.isConversationStarted,
        updatePreferredLanguage: store.updatePreferredLanguage,
        preferredLanguage: store.preferredLanguage,
        escapeHTML: store.escapeHTML,
        rtl: store.rtl
    });
})((0, react_intl_1.injectIntl)((0, mobx_react_1.observer)(BotInfoPage)));
